/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Legal_Footer_VersionInputs */

const tr_legal_footer_version = /** @type {(inputs: Legal_Footer_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sürüm: ${i?.version}`)
};

const en_legal_footer_version = /** @type {(inputs: Legal_Footer_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Version: ${i?.version}`)
};

const de_legal_footer_version = /** @type {(inputs: Legal_Footer_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Version: ${i?.version}`)
};

const ru_legal_footer_version = /** @type {(inputs: Legal_Footer_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Версия: ${i?.version}`)
};

/**
* | output |
* | --- |
* | "Version: {version}" |
*
* @param {Legal_Footer_VersionInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const legal_footer_version = /** @type {((inputs: Legal_Footer_VersionInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Footer_VersionInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_legal_footer_version(inputs)
	if (locale === "de") return de_legal_footer_version(inputs)
	if (locale === "ru") return ru_legal_footer_version(inputs)
	return tr_legal_footer_version(inputs)
});